import { Pagination } from '@factorin/domain';

import { withUrl, list } from '../rest';


export interface SystemNotification {
    Uid: string;
    NotificationText: string;
}

const permissionsPart = withUrl('systemnotifications');

export const systemNotifications = {
    list: list<SystemNotification, Pagination.Request>(permissionsPart()).list,
};
